import buildingService from '@/services/building.js';

const initialState = () => {
	return {
		userBuildingId: null,
		buildings: [],
		dropdownBuildings: [],
		building: {},
		selectedBuilding: {},
		searchParams: {
			customerId: '',
			name: '',
			orderBy: 'Created',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	};
};

const state = initialState();

export default {
	debug: false,
	namespaced: true,
	state,
	mutations: {
		SET_DROPDOWN_BUILDINGS(state, buildings) {
			state.dropdownBuildings = buildings;
		},
		SET_BUILDINGS(state, buildings) {
			state.buildings = buildings;
		},
		SET_BUILDING(state, building) {
			state.building = building;
		},
		SET_USER_BUILDING_ID(state, userId) {
			state.userBuildingId = userId;
		},
		SET_SELECTED_BUILDING(state, building) {
			state.selectedBuilding = building;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		},
		RESET(state) {
			Object.assign(state, initialState());
		}
	},

	actions: {
		async getBuilding({ commit }, buildingId) {
			return await buildingService
				.getBuilding(buildingId)
				.then(data => {
					commit('SET_BUILDING', data);
				})
				.catch(err => {
					console.log('Error getting building: ', err);
				});
		},
		async getBuildings({ state, commit, dispatch }) {
			dispatch('appStore/setLoading', 1, { root: true });

			return await buildingService
				.getBuildings(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_BUILDINGS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getBuildings');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting buildings: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getCustomerBuildings({ commit, dispatch, rootGetters }, name) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				name: name,
				customerId: rootGetters['user/getActiveCustomer']?.id,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 10
			};

			return await buildingService
				.getBuildings(searchParams)
				.then(data => {
					commit('SET_BUILDINGS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting roles: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},

		async createBuilding({ dispatch }, building) {
			return await buildingService
				.createBuilding(building)
				.then(() => {
					dispatch('getBuildings');
				})
				.catch(err => {
					console.log('Error creating building: ', err);
				});
		},
		async updateBuilding({ dispatch }, building) {
			return await buildingService
				.updateBuilding(building)
				.then(() => {
					dispatch('getBuildings');
				})
				.catch(err => {
					console.log('Error updating building: ', err);
				});
		},
		async deleteBuilding({ dispatch }, building) {
			building.deleted = true;

			return await buildingService
				.updateBuilding(building)
				.then(() => {
					dispatch('getBuildings');
				})
				.catch(err => {
					console.log('Error deleting building: ', err);
				});
		},

		setUserBuildingId({commit}, userId) {
			commit('SET_USER_BUILDING_ID', userId);
		},
		setBuilding({ commit }, building) {
			commit('SET_BUILDING', building);
		},
		setSelectedBuilding({ commit }, building) {
			commit('SET_SELECTED_BUILDING', building);
		},
		setBuildings({ commit }, buildings) {
			commit('SET_BUILDINGS', buildings);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		getUserBuildingId: state => {
			return state.userBuildingId;
		},
		buildings: state => {
			return state.buildings;
		},
		building: state => {
			return state.building;
		},
		dropdownBuildings: state => {
			return state.dropdownBuildings;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		},
		selectedBuilding: state => {
			return state.selectedBuilding;
		}
	}
};
